import { Navigate } from '@tanstack/react-router'
import { useEffect } from 'react'

import { type System, useAuth } from '@/lib/auth-store'
import { type LoginSearch, afterLoginPath } from '@/lib/return-path'
import { ensureAuth } from '@/lib/session'

/**
 * The anonymous half of the guard (D5), shared by every auth entry page: a cold
 * visit probes `…/me` once so a live cookie skips the form; render the returned
 * element (a Navigate to the return path) when the session turns out live.
 */
export function useAnonymousOnly(system: System, search: LoginSearch) {
  const auth = useAuth(system)
  useEffect(() => {
    void ensureAuth(system).catch(() => {})
  }, [system])
  return auth.status === 'authenticated' ? <Navigate to={afterLoginPath(search, system)} replace /> : null
}
